import { useTheme } from "@emotion/react";
import React, { useContext } from "react";
import { CcRootContext } from "../../conversionCenterRoot";
import { sortByPosition, checkExternalUrl, getArrayLastItem } from "../../helpers/helpers";
import CcList from "../ccList";
import CcLinkButton from "../ccLinkButton";

export const Pdf = ({ items, defaultScreen, preview, draftId, ...props}) => {
  const theme = useTheme();
  const ctx = useContext(CcRootContext);
  const current = defaultScreen ||  getArrayLastItem(ctx.history);
  const hasContactPage = ctx.sites
    .find((site) => site.specialtyName === current.activeSpecialty)
    .elements.find((el) =>  el.active && el.type === "Contact");

  const linkStyle = {
    backgroundColor: theme.colors.white,
    border: 0,
    borderRadius: 3,
    boxShadow: "0px 1px 5px rgba(0,0,0,0.2)",
    boxSizing: "border-box",
    color: theme.colors.primary,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    minHeight: 39,
    width: "100%",
    padding: "5px 16px",
    textDecoration: "none",
    transition: "all .2s ease-in-out",
    wordBreak: "break-word",
    "&:hover": {
      backgroundColor: theme.colors.primary,
      color: theme.colors.white,
    },
  };

  return(
    items?.length > 0 && (
      <>
        <CcList>
          {sortByPosition(items).map((item) => (
            <a
              css={linkStyle}
              key={item.numberInOrder}
              href={item.pdfLink || checkExternalUrl(item.webLink)}
              target="_blank"
              rel={"noopener noreferrer"}
              {...props}
            >
              {item.linkTitle}
            </a>
          ))}
        </CcList>
        {hasContactPage?.id && (
          <CcLinkButton
            data={{
              btnData: {
                buttonTitle: "Want a personalized evaluation?",
                numberInOrder: "questionary",
              },
              speciality: current.activeSpecialty,
              contentType: "contactScreen",
              id: hasContactPage.id,
            }}
            alternative
          />
        )}
      </>
    )
  );
};
